/**
 * `NumLabel` — ported from `Foyer_Dashboard_CURRENT.jsx` line 208.
 * Mono uppercase kicker. The zero-padded step number (`n`) is accepted
 * for back-compat with existing call sites but no longer rendered — the
 * numbers were per-view-hardcoded (not a real running index; several
 * unrelated views independently pass `n={1}`) and read as broken
 * wherever a view's number didn't match its position in the nav.
 */

import type { ReactNode } from 'react';

import { useC } from '../../lib/theme.js';

export interface NumLabelProps {
  n: number;
  children: ReactNode;
}

const monoFont = "'JetBrains Mono', monospace";

export function NumLabel({ children }: NumLabelProps): JSX.Element {
  const C = useC();
  return (
    <div className="flex items-center gap-3 mb-6">
      <span
        style={{
          fontFamily: monoFont,
          color: C.muted,
          fontSize: 11,
          letterSpacing: 2,
          textTransform: 'uppercase',
        }}
      >
        {children}
      </span>
    </div>
  );
}
